/**
 * @generated SignedSource<<ac212fc24d829e21fe27e6cd2e5b8f0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveSubscriptionAmountOverrideInput = {
  id: string;
};
export type RemoveSubscriptionAmountOverrideDialogMutation$variables = {
  input: RemoveSubscriptionAmountOverrideInput;
};
export type RemoveSubscriptionAmountOverrideDialogMutation$data = {
  readonly removeSubscriptionAmountOverride: {
    readonly id: string;
  };
};
export type RemoveSubscriptionAmountOverrideDialogMutation = {
  response: RemoveSubscriptionAmountOverrideDialogMutation$data;
  variables: RemoveSubscriptionAmountOverrideDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IdPayload",
    "kind": "LinkedField",
    "name": "removeSubscriptionAmountOverride",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveSubscriptionAmountOverrideDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveSubscriptionAmountOverrideDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "72e92f48025016d2b9884cb9ab39295f",
    "id": null,
    "metadata": {},
    "name": "RemoveSubscriptionAmountOverrideDialogMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveSubscriptionAmountOverrideDialogMutation(\n  $input: RemoveSubscriptionAmountOverrideInput!\n) {\n  removeSubscriptionAmountOverride(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a72f6cd6fb8e5b34737f674e7d55222";

export default node;
